import SessionOptions from "seneca-common/features/session/models/SessionOptions";

export function getHasHardestQuestionContent(options?: SessionOptions) {
  return options?.hasHardestQuestionContent;
}
